import React, { lazy } from "react";

const Homepage = lazy(() => import("./components/Homepage/Homepage"));
const SignIn = lazy(() => import("./components/features/SignIn/SignIn"));
const HomeDashboarcard = lazy(() =>
  import("./components/Homepage/Homedashboardcard/homeDashboarcard")
);
const HealthDashboard = lazy(() =>
  import("./components/features/HealthDashboard/HealthDashboard")
);
const OtpValidation = lazy(() =>
  import("./components/features/OtpValidation/otpValidation")
);
const LabTests = lazy(() => import("./components/features/Labtests/labTest"));
const RadTest = lazy(() => import("./components/features/Labtests/radTest"));
const DoctorList = lazy(() => import("./components/Doctors/Doctors"));
const ContactUs = lazy(() => import("./components/ContactUs/contactUs"));
const BloodPressureMonitor = lazy(() =>
  import("./components/features/DashBoardItems/BloodPressure/bloodPressure")
);
const BmiComponent = lazy(() =>
  import("./components/features/DashBoardItems/Bmi/bmiPage")
);
const PlateletMonitor = lazy(() =>
  import("./components/features/DashBoardItems/Platelets/plateletsPage")
);
const HemoglobinMonitor = lazy(() =>
  import("./components/features/DashBoardItems/HBComponent/hbPage")
);
const WbcMonitor = lazy(() =>
  import("./components/features/DashBoardItems/WhiteBloodCells/whiteBlood")
);
const Ft4Monitor = lazy(() =>
  import("./components/features/DashBoardItems/FT4Page/ft4Page")
);
const Ft3Monitor = lazy(() =>
  import("./components/features/DashBoardItems/FT3Page/ft3Page")
);
const TshMonitor = lazy(() =>
  import("./components/features/DashBoardItems/TSHPage/tshPage")
);
const AddVitalsbp = lazy(() =>
  import(
    "./components/features/DashBoardItems/AddVitals/bpush/bloodpressurecall"
  )
);
const AddVitalsbmi = lazy(() =>
  import("./components/features/DashBoardItems/AddVitals/bmipush/bmicall")
);
const AddVitalsplatelets = lazy(() =>
  import(
    "./components/features/DashBoardItems/AddVitals/plateletspush/plateletscall"
  )
);
const AddVitalsHemoglobin = lazy(() =>
  import("./components/features/DashBoardItems/AddVitals/hbpush/hbpushcall")
);
const AddVitalsWbc = lazy(() =>
  import("./components/features/DashBoardItems/AddVitals/wbcpush/wbcpushcall")
);
const AddVitalsft3 = lazy(() =>
  import("./components/features/DashBoardItems/AddVitals/ft3push/ft3pushcall")
);
const AddVitalsft4 = lazy(() =>
  import("./components/features/DashBoardItems/AddVitals/ft4push/ft4pushcall")
);
const AddVitalstsh = lazy(() =>
  import("./components/features/DashBoardItems/AddVitals/tshpush/tshpushcall")
);
const AddPatient = lazy(() =>
  import("./components/Homepage/AddPatient/addPatient")
);
const AppointmentList = lazy(() =>
  import("./components/AppointmentComponent/Appointments/appoointmentList")
);
const AppointmentComponent = lazy(() =>
  import("./components/AppointmentComponent/BookAppointmetns/bookaAppointments")
);
const ReportListComponent = lazy(() =>
  import(
    "./components/features/HealthDashboard/reportsfunction/reportsFucntion"
  )
);
const YouTubeFeaturedVideo = lazy(() =>
  import("./components/YoutubeComponent/ytComponent")
);
const BlogList = lazy(() =>
  import("./components/BlogComponent/BlogList/blogList")
);
const BlogComponent = lazy(() =>
  import("./components/BlogComponent/blogComponent")
);
const AddressComponent = lazy(() =>
  import("./components/ContactUs/address/address_maps")
);
const Reschedule = lazy(() =>
  import("./components/AppointmentComponent/Appointments/reschdeulingComponent")
);
const QRCodeComponent = lazy(() =>
  import("./components/features/QrCode/qrCode")
);
const PaymentProcesssing = lazy(() =>
  import("./components/PaymentProcessingPage/PaymentProcessingPage")
);
const Consultation = lazy(() =>
  import("./components/AppointmentComponent/Consultation")
);

const DeleteFiles = lazy(() =>
  import("./components/AppointmentComponent/DeleteFiles/deleteFiles")
);

const AppoinetmentConfirmation = lazy(() =>
  import("./components/AppointmentComponent/appointmentConfirmation")
);

const PaidReschedule = lazy(() =>
  import("./components/AppointmentComponent/PaidRescheduling/paidRescheduling")
);

const AppointmentInstructions = lazy(() =>
  import("./components/AppointmentComponent/appointmentInstructions"));

const DialysisAppointmentScreen = lazy(() =>
  import("./components/AppointmentComponent/DialysisAppointment/dialysisAppointment"));

export const routes = [
  { path: "/", element: <Homepage /> },
  { path: "/dashboard", element: <HealthDashboard /> },
  { path: "/signin", element: <SignIn /> },
  { path: "/homedashboard", element: <HomeDashboarcard /> },
  { path: "/otp", element: <OtpValidation /> },
  { path: "/labtest", element: <LabTests /> },
  { path: "/radtest", element: <RadTest /> },
  { path: "/doctors", element: <DoctorList /> },
  { path: "/contact", element: <ContactUs /> },
  { path: "/blood-pressure", element: <BloodPressureMonitor /> },
  { path: "/bmi", element: <BmiComponent /> },
  { path: "/platelets", element: <PlateletMonitor /> },
  { path: "/hemoglobin-(hb)", element: <HemoglobinMonitor /> },
  { path: "/white-blood-cells-(wbc)", element: <WbcMonitor /> },
  { path: "/free-t3", element: <Ft3Monitor /> },
  { path: "/free-t4", element: <Ft4Monitor /> },
  { path: "/tsh", element: <TshMonitor /> },
  { path: "/bppush", element: <AddVitalsbp /> },
  { path: "/bmipush", element: <AddVitalsbmi /> },
  { path: "/platepush", element: <AddVitalsplatelets /> },
  { path: "/hbpush", element: <AddVitalsHemoglobin /> },
  { path: "/wbcpush", element: <AddVitalsWbc /> },
  { path: "/ft3push", element: <AddVitalsft3 /> },
  { path: "/ft4push", element: <AddVitalsft4 /> },
  { path: "/tshpush", element: <AddVitalstsh /> },
  { path: "/add-patient", element: <AddPatient /> },
  { path: "/appointlist", element: <AppointmentList /> },
  { path: "/bookappointment", element: <AppointmentComponent /> },
  { path: "/reportfunction", element: <ReportListComponent /> },
  { path: "/youtube", element: <YouTubeFeaturedVideo /> },
  { path: "/blog-list", element: <BlogList /> },
  { path: "/blog", element: <BlogComponent /> },
  { path: "address", element: <AddressComponent /> },
  { path: "/reschedule", element: <Reschedule /> },
  { path: "/mrc-card", element: <QRCodeComponent /> },
  { path: "/payment-processing", element: <PaymentProcesssing /> },
  { path: "/consultation", element: <Consultation /> },
  { path: "/view-files", element: <DeleteFiles /> },
  { path: "/confirmation", element: <AppoinetmentConfirmation /> },
  { path: "/Paidrescheduling", element: <PaidReschedule /> },
  { path: "/apptInstructions", element: <AppointmentInstructions /> },
  { path: "/dialysis-appointments", element: <DialysisAppointmentScreen /> },
];
